<template>
  <div></div>
</template>
<script>
import { mapActions } from 'vuex'
import linkToPayData from '@/mixins/linkToPayData.js'

export default {
  name: 'Loading',
  components: {},
  mixins: [linkToPayData],
  methods: {
    ...mapActions('linkToPay', ['toggleLoading'])
  },
  computed: {},
  beforeDestroy () {
    this.toggleLoading(false)
  },
  created () {
    this.toggleLoading(true)
    this.initPolling()
  }
}
</script>